import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "showMoreButton"]
  static values = {
    initialCount: Number,
    animationDelay: { type: Number, default: 50 },
    fadeOutDuration: { type: Number, default: 300 }
  }

  connect() {
    try {
      this.visibleCount = this.initialCountValue || 6
      this.incrementCount = 6 // Nombre de cartes à ajouter à chaque clic
    } catch (error) {
      console.error('Error initializing ScpiGridController:', error)
      this.visibleCount = 6
      this.incrementCount = 6
    }
  }

  loadMore() {
    try {
      // Check if targets exist
      if (!this.hasCardTarget) {
        console.warn('No card targets found')
        return
      }

      const totalCards = this.cardTargets.length
      const previousCount = this.visibleCount
      const newCount = Math.min(this.visibleCount + this.incrementCount, totalCards)

      // Afficher les prochaines cartes avec animation
      this.cardTargets.forEach((card, index) => {
        if (index >= previousCount && index < newCount) {
          card.classList.remove('hidden')

          // Animation d'apparition style home (plus subtile)
          card.style.opacity = '0'
          card.style.transform = 'translateY(10px)'

          setTimeout(() => {
            card.style.transition = 'all 0.3s ease-out'
            card.style.opacity = '1'
            card.style.transform = 'translateY(0)'
          }, (index - previousCount) * this.animationDelayValue) // Décalage configurable
        }
      })

      this.visibleCount = newCount

      // Si toutes les cartes sont visibles, cacher le bouton
      if (this.visibleCount >= totalCards && this.hasShowMoreButtonTarget) {
        this.showMoreButtonTarget.style.opacity = '0'
        setTimeout(() => {
          if (this.hasShowMoreButtonTarget) {
            this.showMoreButtonTarget.style.display = 'none'
          }
        }, this.fadeOutDurationValue) // Durée configurable
      }
    } catch (error) {
      console.error('Error in loadMore:', error)
    }
  }
}